import type * as Types from '../../graphql/types.d'

import type { DocumentNode } from 'graphql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type CreateStripeAccountMutationVariables = Types.Exact<{
	firstName: Types.Scalars['String']['input']
	lastName: Types.Scalars['String']['input']
	username: Types.Scalars['String']['input']
}>

export type CreateStripeAccountMutation = {
	__typename?: 'Mutation'
	createStripeAccount: {
		__typename: 'User'
		id: string
		email: string
		emailVerified: boolean
		username?: string | null
		fullName?: string | null
		currentName: string
		currentProfilePictureUrl: string
		pictureURL?: string | null
		hasSellerId: boolean
	}
}

export type FetchStripeAccountQueryVariables = Types.Exact<{ [key: string]: never }>

export type FetchStripeAccountQuery = {
	__typename?: 'Query'
	fetchStripeAccount: {
		__typename?: 'StripeAccount'
		id: string
		email?: string | null
		chargesEnabled?: boolean | null
		detailsSubmitted?: boolean | null
		payoutsEnabled?: boolean | null
		defaultCurrency?: string | null
	}
}

export type FetchStripeAccountTransactionsQueryVariables = Types.Exact<{ [key: string]: never }>

export type FetchStripeAccountTransactionsQuery = {
	__typename?: 'Query'
	fetchStripeAccountTransactions: Array<{
		__typename?: 'Transaction'
		id: string
		amount?: number | null
		currency?: string | null
		created?: number | null
		status?: string | null
	} | null>
}

export type FetchStripeAccountOnboardingLinkQueryVariables = Types.Exact<{ [key: string]: never }>

export type FetchStripeAccountOnboardingLinkQuery = {
	__typename?: 'Query'
	fetchStripeAccountOnboardingLink: string
}

export type FetchStripeDashboardLinkQueryVariables = Types.Exact<{ [key: string]: never }>

export type FetchStripeDashboardLinkQuery = {
	__typename?: 'Query'
	fetchStripeDashboardLink: string
}

export type FetchCouponCodesQueryVariables = Types.Exact<{ [key: string]: never }>

export type FetchCouponCodesQuery = {
	__typename?: 'Query'
	fetchCouponCodes: Array<{
		__typename: 'Coupon'
		numPurchases: number
		id: string
		code: string
		state: Types.CouponState
		discount: number
		createdAt: string
		listings?: Array<{ __typename: 'Listing'; id: string; title?: string | null }> | null
	} | null>
}

export const CreateStripeAccountDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'CreateStripeAccount' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'username' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'createStripeAccount' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'firstName' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'lastName' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'username' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'username' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CurrentUserFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'CurrentUserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'pictureURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'hasSellerId' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const FetchStripeAccountDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'FetchStripeAccount' },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'fetchStripeAccount' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StripeAccountFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'StripeAccountFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StripeAccount' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'chargesEnabled' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'detailsSubmitted' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'payoutsEnabled' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'defaultCurrency' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const FetchStripeAccountTransactionsDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'FetchStripeAccountTransactions' },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'fetchStripeAccountTransactions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'StripeTransactionFields' },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'StripeTransactionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Transaction' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'amount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'created' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'status' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const FetchStripeAccountOnboardingLinkDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'FetchStripeAccountOnboardingLink' },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'fetchStripeAccountOnboardingLink' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const FetchStripeDashboardLinkDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'FetchStripeDashboardLink' },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [{ kind: 'Field', name: { kind: 'Name', value: 'fetchStripeDashboardLink' } }],
			},
		},
	],
} as unknown as DocumentNode
export const FetchCouponCodesDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'FetchCouponCodes' },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'fetchCouponCodes' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CouponFields' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'numPurchases' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'CouponFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Coupon' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'code' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'state' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'discount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'listings' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode
